import React from 'react';
import PropTypes from 'prop-types';

export function PCRTubeHintsBlock(props) {
  return props.hasPCRTube ? (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3>HINT</h3>
        <p className={`${props.className}_message`}>
          PCR Tubes are smaller than the average lab tubes. So they need an
          adaptor when spinning.
        </p>
      </div>
    </div>
  ) : null;
}

PCRTubeHintsBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set if slots have a PCR Tube.
   */
  hasPCRTube: PropTypes.bool,
};

PCRTubeHintsBlock.defaultProps = {};
